/**
 * @todo populate the env variable during the deployment process, maintain consistency between server and client env, remove te workaround once done
 */
export const isProd = (hostname) => hostname === 'www.earnin.com'
